import { config } from "../../../../config"
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ProfileForm from "./ProfileForm";
import { userApi, resetUserSliceStatus } from '../../reducers/userSlice';

const InvitationPopup = ({ onToggle }) => {
    const status = useSelector((state) => state.userReducer.status);
    const dispatch = useDispatch()

    useEffect(() => {
        if(status === "user/create/succeeded") {
            dispatch(resetUserSliceStatus())
            if(onToggle) onToggle() 
        } 
    }, [dispatch, status, onToggle])

    const onModalToggle = () => {
        if(onToggle) onToggle()
    }

    const onUserInvited = (data) => {
        delete data.id
        const invitation = {...data, privacy: true, terms: true, invitation: true}

        dispatch(userApi.create(invitation))
    }

    return (
        <Modal
            isOpen={true}
            toggle={() => { onModalToggle() }}
            size="xl"
            className={config.instance.id}
        >
            <ModalHeader toggle={() => { onModalToggle() }}>
                <b>Invita utente</b>
            </ModalHeader>
            <ModalBody>
                <ProfileForm 
                    onSaveProfile={(data) => { onUserInvited(data) }} 
                    btnProfileLabel="Invita" 
                    showPasswordTab={false} 
                    initWithMe={false}
                />
            </ModalBody>
        </Modal>
    );
};

export default InvitationPopup;